import { render, staticRenderFns } from "./BadgeChartNative.vue?vue&type=template&id=fa189a8c&scoped=true"
import script from "./BadgeChartNative.vue?vue&type=script&lang=js"
export * from "./BadgeChartNative.vue?vue&type=script&lang=js"
import style0 from "./BadgeChartNative.vue?vue&type=style&index=0&id=fa189a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa189a8c",
  null
  
)

export default component.exports